import { userProfileHttpClient as client } from '@/api/userProfile/client';
import { ProfileType } from '@/models/user/userProfile';

export type FavoriteApiParams = {
  userId: string;
  profileBk: string;
  profileType: ProfileType;
};

export type FavoriteHcpApiParams = {
  userId: string;
  hcpBk: string;
};

export type FavoriteHcoApiParams = {
  userId: string;
  hcoBk: string;
};

export const FavoriteApiService = {
  add: ({ profileBk, profileType, userId }: FavoriteApiParams) =>
    client.post(`/users/${userId}/favorites`, { profileBk, profileType }),
  remove: ({ profileBk, profileType, userId }: FavoriteApiParams) =>
    client.delete(`/users/${userId}/favorites`, {
      data: { profileBk, profileType },
    }),
};
